import React from 'react';
import { withRouter } from 'react-router-dom';
import scrollTo from './scrollTo';

class ScrollToTop extends React.Component {

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
    	//hacked into this to preserve scroll positions for nested routes
    	if(this.props.location.pathname !== '/dashboard/resetpass' && this.props.location.pathname !== '/dashboard/deactivate'){
          setTimeout(() => {
            window.scrollTo(0, 0);
            if (this.props.location.hash) {
              const navbar = document.getElementById('navbar');
              const navbarHeight = navbar.offsetHeight || navbar.clientHeight;
              const targetEl = document.getElementById(this.props.location.hash);
              scrollTo(targetEl, 600, 'easeInOutQuart', navbarHeight);
            }
          }, 0)
    	}
    }
  }
  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./src/helpers/ScrollToTop.js